function init() {
  const { google } = window;
  const el = document.getElementById('google-map');
  const query = el.getAttribute('data-google-map-query');

  const map = new google.maps.Map(el, {
    zoom: 15,
    disableDefaultUI: true,
    // disable all controls:
    draggable: false,
    scrollwheel: false,
    panControl: false,
    clickableIcons: false,
    gestureHandling: 'none',
    keyboardShortcuts: false,
  });

  const service = new google.maps.places.PlacesService(map);
  const request = {
    query,
    fields: ['geometry'],
  };

  service.findPlaceFromQuery(request, (results, status) => {
    if (status !== google.maps.places.PlacesServiceStatus.OK) {
      return;
    }

    const marker = new google.maps.Marker({
      map,
      position: results[0].geometry.location,
    });

    map.setCenter(marker.getPosition());
  });
};

export default {init};
